import { render, staticRenderFns } from "./insurance-image-upload.vue?vue&type=template&id=a2997052&"
import script from "./insurance-image-upload.vue?vue&type=script&lang=js&"
export * from "./insurance-image-upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports